<template>
	<footer class="v-resume-footer">
		<p class="v-resume-footer__item v-resume-footer--hidden-sm"><a href="mailto:support@vcv.me" target="_blank" rel="noopener">support@vcv.me</a></p>
		<p class="v-resume-footer__item">{{$tr('videoresume.footer.madeOn')}} <a class="v-resume-footer__emphasized" :href="vcvMeLink" target="_blank" rel="noopener">vcv.me</a></p>
		<p class="v-resume-footer__item"><a :href="vcvLink" target="_blank" rel="noopener">{{$tr('videoresume.footer.forBusiness')}}</a></p>
	</footer>
</template>

<script>
export default {
	name: 'v-resume-footer',
	props: ['vcvMeLink', 'vcvLink']
}

</script>
<style lang="scss" scoped>
.v-resume-footer {
	width: 100%;
	padding: 40px 36px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	box-sizing: border-box;
	// // font-family: 'Euclid Circular A';

	@media only screen and (min-width: 1025px) and (max-height: 870px) {
      padding: 16px 36px;
    }

	@media only screen and (max-width: 1024px) {
		margin: 0 auto;
		width: 640px;
		max-width: calc(100% - 80px);
		padding-left: 0;
		padding-right: 0;
	}

	&__item {
		font-size: 12px;
		line-height: 16px;
		color: #8D8D8D;

		a {
			color: #8D8D8D;
		}
	}

	&__emphasized {
		font-size: 16px;
	}

	a {
		&:hover {
			transition: color .35s ease;
			background: linear-gradient(278deg, #535DC1 0%, #A364D6 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}
	}
}

@media (max-width: 480px) {
	.v-resume-footer {
		flex-flow: column;
		padding-top: 28px;

		&__item:not(:last-child) {
			margin-bottom: 16px;
		}
	}

	.v-resume-footer--hidden-sm {
		display: none;
	}
}
</style>
